import _ from 'lodash'

/**
 * Assigns a "linkGroup" property to each object in the collection that does not already have an "linkGroup" property.
 * The value of the assigned property is determined by finding the highest "linkGroup" already existing in the collection
 * and incrementing that value by 1 for each object that does not have an "linkGroup" property.  If no objects have an
 * "linkGroup" property, the initial value starts at 0.  Returns the highest "linkGroup" value (after assignment) + 1.
 *
 * For example given the array [{name: 'a'},{name: 'b', linkGroup: 5}, {name: 'c'}) after calling this function the array
 * will contain [{name: 'a', linkGroup:6},{name: 'b', linkGroup: 5}, {name: 'c', linkGroup: 7}] and the function would return
 * a value of 8
 *
 * @param filters
 * @returns {number}
 */
function assignLinkGroups(filters) {
	const maxLinkGroup = _(filters).map(f => f.linkGroup).max()
	let linkGroup = _.isNil(maxLinkGroup) ? 0 : maxLinkGroup + 1
	_.each(filters, f => {
		if (_.isNil(f.linkGroup)) {
			f.linkGroup = linkGroup++
		}
	})
	return linkGroup
}

export default assignLinkGroups

assignLinkGroups.__filename__ = 'components/assign-link-groups.js'
